import messages from '../../i18n/messages';
import moment from 'moment';

export const notEmpty = (value) => (!value ? messages.input.required : '');

export const notEmptySelect = (value) => (!value ? 'Vui lòng chọn từ danh sách' : '');

export const isValidDate = (value) => {
  if (!value) return;
  if ((value || '').includes('_')) return messages.input.invalidDate;
  let date = moment(value, 'DD/MM/YYYY');
  if (!date.isValid()) return messages.input.invalidDate;
  return '';
};

export const isValidDob = (value) => {
  if (!value) return messages.input.invalidDate;
  if ((value || '').includes('_')) return messages.input.invalidDate;
  let dob = moment(value, 'DD/MM/YYYY');
  if (!dob.isValid()) return messages.input.invalidDate;

  let now = moment();
  if (dob.isAfter(now)) return 'Ngày tháng năm sinh không hợp lệ';
  let age = now.diff(dob, 'year');
  if (age < 0 || age > 150) return 'Ngày tháng năm sinh không hợp lệ';

  return '';
};
